// Shared formatting helpers for the Zeiterfassung pages
export const formatTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
};

/**
 * Wandelt einen ISO-Zeitstempel (z.B. "2026-04-30T06:00:00Z") in einen
 * lokalen "HH:MM"-String um — passend zum Browser-Tz (fuer deutsche Nutzer
 * typischerweise Europe/Berlin). Gibt leeren String bei fehlendem Input
 * zurueck, damit er direkt in <Input type="time" /> landet.
 */
export const isoToLocalHHMM = (isoString) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

/**
 * Kombiniert ein Datum (YYYY-MM-DD) + lokale Zeit ("HH:MM") zu einem
 * UTC-ISO-String. Interpretiert HH:MM als Browser-Lokalzeit — also das,
 * was der Nutzer gerade im time-Input sieht.
 */
export const localDateTimeToUtcIso = (dateStr, hhmm) => {
  if (!dateStr || !hhmm) return null;
  const [h, m] = hhmm.split(':').map((v) => parseInt(v, 10));
  const [y, mo, d] = dateStr.split('-').map((v) => parseInt(v, 10));
  if ([h, m, y, mo, d].some((v) => Number.isNaN(v))) return null;
  // new Date(y, mo-1, d, h, m) interpretiert die Werte als Lokalzeit
  const local = new Date(y, mo - 1, d, h, m, 0, 0);
  return local.toISOString();
};

export const formatMinutes = (minutes) => {
  if (!minutes && minutes !== 0) return '-';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const decimal = (minutes / 60).toFixed(2);
  return `${hours}:${mins.toString().padStart(2, '0')} (${decimal})`;
};

export const formatDecimalHours = (value) => {
  if (value === null || value === undefined) return '-';
  const num = parseFloat(value);
  if (isNaN(num)) return '-';
  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);
  const h = Math.floor(abs);
  const m = Math.round((abs - h) * 60);
  return `${sign}${h}:${m.toString().padStart(2, '0')} (${num.toFixed(2)})`;
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
};

export const getWeekEnd = (startDate) => {
  const date = new Date(startDate);
  date.setDate(date.getDate() + 6);
  return date.toISOString().split('T')[0];
};

export const getGreeting = (hour) => {
  if (hour < 12) return 'Morgen';
  if (hour < 18) return 'Tag';
  return 'Abend';
};
